import ProcessingIndicator from "../ProcessingIndicator";

export default function ProcessingOverlay({isVisible, processingTitle}) {
  return isVisible ?
    (
      <div className="z-50 fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-40 flex flex-row items-center justify-center">
        <ProcessingIndicator className="transform-gpu scale-125"
                             size="extralarge"
                             title={processingTitle}/>
      </div>
    ) :
    null;
}
